module.exports = "<input #inputControl\r\n       [ngClass]=\"cssClass\" \r\n       [ngStyle]=\"cssStyle\" \r\n       [id]=\"inputId\"\r\n       [placeholder]=\"placeholder\" \r\n       type=\"text\" \r\n       [ngModel]=\"innerValue\" \r\n       (ngModelChange)=\"innerValueChange($event)\" \r\n       [disabled]=\"disabled  ? 'disabled':null\"\r\n       [readOnly]=\"readOnly  ? 'readOnly':null\"\r\n        />"


//////////////////
// WEBPACK FOOTER
// ./src/angular_library/components/input-number/input-number.html
// module id = ./src/angular_library/components/input-number/input-number.html
// module chunks = main